import React from 'react';

export default function MatchStatsChips({ match, events = [] }) {
  const ev = events.length ? events : match?.events || [];
  const goals = ev.filter((e) => e.type === 'goal');
  const cards = ev.filter((e) => e.type?.includes('card'));
  const subs = ev.filter((e) => e.type === 'subst');

  const chips = [
    goals.length > 0 && { label: `${goals.length} goal${goals.length !== 1 ? 's' : ''}`, tone: 'goals' },
    cards.length > 0 && { label: `${cards.length} card${cards.length !== 1 ? 's' : ''}`, tone: 'cards' },
    subs.length > 0 && { label: `${subs.length} sub${subs.length !== 1 ? 's' : ''}`, tone: 'subs' },
    match?.hasLiveStats && { label: 'Live stats', tone: 'stats' },
  ].filter(Boolean);

  if (!chips.length) return null;

  return (
    <div className="px-4 pb-3 flex flex-wrap gap-2">
      {chips.map((c) => (
        <span key={c.label} className={`sw-stat-chip sw-stat-chip--${c.tone}`}>
          {c.label}
        </span>
      ))}
    </div>
  );
}
